import * as React from 'react';
const SvgList = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.2 2.803a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zm2.8 1.2a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zm1 3a1 1 0 100 2h10a1 1 0 100-2H5zm0 4a1 1 0 000 2h10a1 1 0 100-2H5zm-3.8-.2a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4zM0 8.003a1.2 1.2 0 112.4 0 1.2 1.2 0 01-2.4 0z"
            fill="currentColor"
        />
    </svg>
);
export default SvgList;
